import React, { FC } from "react"

interface IProps {
  value: boolean
  handler: any
}

export const Toggle: FC<IProps> = (props) => {
  const { value, handler } = props
  return (
    <>
      <button
        onClick={() => handler(!value)}
        className={`rounded-full w-10 h-6 relative transition-all duration-300 ${value ? "bg-green" : "bg-white dark:bg-grey-med-2"}`}
      >
        <div
          className={`rounded-full w-4 h-4 absolute top-1 transition-all duration-300 ${
            value ? "left-5 bg-grey-light-2 dark:bg-grey-med-2" : "left-1 bg-grey-light"
          }`}
        ></div>
      </button>
    </>
  )
}
